import { useEffect } from 'react';
export function useObserveElement(observerManager, element, callback) {
  useEffect(() => {
    if (observerManager && element) {
      observerManager.subscribe(element, callback);
    }
    return () => {
      if (observerManager && element) {
        observerManager.unsubscribe(element);
      }
    };
  }, [element, observerManager, callback]);
}